import { PriceUtils } from '../price/price-mapper';
var PaymentDtoMapper = /** @class */ (function () {
    function PaymentDtoMapper(regionalSettings) {
        this.regionalSettings = regionalSettings;
    }
    PaymentDtoMapper.prototype.priceText = function (paymentDto, currencyDisplay) {
        var isFree = paymentDto.isFree, priceText = paymentDto.priceText, currency = paymentDto.currency, price = paymentDto.price;
        var shouldShowPrice = !isFree && price;
        if (priceText) {
            return priceText;
        }
        if (shouldShowPrice) {
            return PriceUtils.getFormattedCurrency({
                price: price,
                currency: currency,
                locale: this.regionalSettings,
                currencyDisplay: currencyDisplay,
            });
        }
        return '';
    };
    return PaymentDtoMapper;
}());
export { PaymentDtoMapper };
//# sourceMappingURL=payment-dto.mapper.js.map